
// src/connects/kpi-chart-ranking-table.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import moment from 'moment'
import map from 'lodash/map'
import _sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import reduce from 'lodash/reduce'
import { groupBy } from 'lodash'; // Ensure lodash is imported for data manipulation

export function calcUserTableData(selectedKPIs, kpis, t, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  if (!kpis || !Array.isArray(kpis) || kpis.length == 0) {
    return {};
  }

  // Data structure to hold total data per user for each KPI
  var userData = {};

  // Loop over each selected KPI
  map(selectedKPIs, (selected_kpi) => {
    const kpiId = selected_kpi.kpi_id;
    const kpi = kpis.find(kpi => kpi.kpi_id == kpiId);
    if (!kpi) return null;
    
    // For each user in this KPI, aggregate their data
    kpi.assignments.forEach((assignment) => {
      const userId = assignment.user_id;
      // Filter the actual_records by date ranges from original actual_records and re-calculate the "total" field based on filtered_records
      const dateRange = aggregationType == 'cumulative' ? [new Date(tableStartDate), new Date(tableEndDate)] : [new Date(tableSelectedDate), new Date(tableSelectedDate)]
      const filtered_records = assignment.progress.actual_records.filter(item => {
        const reportedDate = new Date(item.reported_at)
        return reportedDate >= dateRange[0] && reportedDate <= dateRange[1]
      })
      let cumulativeTotal = 0
      const updated_records = filtered_records.map(record => {
        cumulativeTotal += record.actual
        return { ...record, total: cumulativeTotal }
      })

      const last_record = updated_records[updated_records.length - 1]

      // If this user doesn't exist in userData yet, initialize
      if (!userData[userId]) {
        userData[userId] = {
          name: assignment.name,
          icon_image: assignment.icon_image,
          userTotalActual: 0,
          userAchievementRate: 0,
          kpiLength: 0,
          kpiData: {},
          user_id: userId,
          unit: kpi.unit,
        };
      }

      // Initialize KPI-specific data for the user if not already present
      const total_target = kpi.accumulated_total ? last_record.target : last_record.target * updated_records.length
      if (!userData[userId].kpiData[kpiId]) {
        userData[userId].kpiData[kpiId] = {
          totalActual: last_record.total,
          totalTarget: last_record.target,
          achievementRate: total_target > 0 && last_record.total / total_target || 0
        };
      }

      // Sum totalAcutal and achievementRate for a user
      userData[userId].userTotalActual += userData[userId].kpiData[kpiId].totalActual
      userData[userId].userAchievementRate += userData[userId].kpiData[kpiId].achievementRate
      userData[userId].kpiLength += 1
    });
  });

  return userData;
}

export function calcRankingData(progress, reported_at, sortBy) {
  const reportdAt = moment(reported_at).format('YYYY-MM-DD').toString()
  const items = map(progress, (item)=> {
    const record = find(item.actual_records, (record)=> reportdAt == record.reported_at)
    const total = typeof record.total == 'undefined' ? record.actual : record.total
    return {
      user_id: item.user_id,
      name: item.name,
      icon_image: item.icon_image,
      target: record.target,
      total: total,
      percent: record.target > 0 ? Math.floor(total * 1000 / record.target) / 1000 : undefined,
    }
  })

  return _sortBy(items, (item)=> item[sortBy] * -1)
}

export function calcRankingTotal(progress, reported_at) {
  const result = reduce(progress, (r, item)=> {
    const record = find(item.actual_records, (record)=> reported_at.isSame(record.reported_at, 'date'))
    const total = typeof record.total == 'undefined' ? record.actual : record.total
    const target = record.target

    return {
      target: r.target + target,
      total: r.total + total,
    }
  }, { target: 0, total: 0 })

  return {
    target: result.target,
    total: result.total,
    percent: result.target > 0 && Math.floor(result.total * 1000 / result.target) / 1000 || undefined
  }
}

export const mapStateToProps = (state, ownProps)=> {
  return {
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
  }
}

export default combineHOC(
  ui({ state: {
    sortBy: 'total',
    reported_at: (props)=> moment.max(moment.min(moment(), moment(props.kpiUI.kpiEndDate)), moment(props.kpiUI.kpiStartDate)),
  }}),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/kpi-chart-ranking-table.js